import { updateLoadingEffect } from './updateLoadingEffect';

/**
 * Map částí zápasu ve sportu na jejich názvy.
 * Přiřazuje kód sportu k jeho názvu periody/fáze.
 */
const sportPeriods: { [key: string]: string } = {
  fot: 'poločas',
  fut: 'poločas',
  haz: 'poločas',
  hok: 'třetina',
  flo: 'třetina',
  hob: 'třetina',
  ten: 'set',
  vol: 'set',
  bas: 'čtvrtina',
  bab: 'inning',
  sob: 'inning',
  mot: 'kolo',
  box: 'kolo',
  default: 'kolo',
};

/**
 * Funkce pro získání názvu periody/fáze zápasu na základě kódu sportu a periody zápasu.
 *
 * @param sport - Kód sportu.
 * @param period - Aktuální perioda zápasu.
 * @returns Jméno periody/fáze zápasu nebo prázdný řetězec.
 */
const getMatchPeriodName = (sport: string, period: string) => {
  if (period === 'k') {
    return '';
  }

  if (['1p', '2p', '3p'].includes(period)) {
    return 'přestávka';
  }

  if (period === 'kn' && ['hok', 'flo'].includes(sport)) {
    return 'Sam. nájezdy';
  }

  if (period === 'kn' && ['fot', 'fut', 'haz'].includes(sport)) {
    return 'Penalty';
  }

  if (period === 'kp' && ['fot', 'hok', 'fut', 'flo', 'haz', 'bas', 'bab', 'sob'].includes(sport)) {
    return 'Po prodl.';
  }

  if (period !== '0' && period !== 'k') {
    const periodName = sportPeriods[sport] || sportPeriods['default'];
    return `${period}. ${periodName}`;
  }
  return '';
};

/**
 * Názvy tříd CSS pro stavy zápasu 'live' a 'fin'.
 * @type {Object}
 * @property {string} liveStatus - CSS třída pro stav 'live'.
 * @property {string} finStatus - CSS třída pro stav 'fin'.
 * @property {string} baseClass - Základní třída CSS.
 */
const classNames = {
  liveStatus: 'match-overview-meta__match-period--live',
  finStatus: 'match-overview-meta__match-period--fin',
  baseClass: 'match-overview-meta__match-period',
};

/**
 * Funkce pro aktualizaci označení fáze zápasu v daném HTML elementu 'data-match-period-update'.
 * V případě aktualizace, je také přidán efekt načítání do daného elementu.
 *
 * @param element - HTMLElement - zápas, který má být aktualizován. Obsahuje HTMLElement s data atributem 'data-match-period-update'.
 * @param xmlStatus - Aktuální stav zápasu (perioda), tak jak byl získán z dat XML.
 */
export const updateMatchPeriodName = (element: HTMLElement | null, xmlStatus: string) => {
  if (!element) return;

  const periodEl = element.querySelector<HTMLElement>('[data-match-period-update]');

  if (periodEl) {
    const sport = periodEl.getAttribute('data-match-sport');
    const period = periodEl.getAttribute('data-match-period-update');
    const updatePeriod = period !== xmlStatus ? xmlStatus : null;

    if (sport && updatePeriod) {
      periodEl.textContent = getMatchPeriodName(sport, updatePeriod);

      periodEl.setAttribute('data-match-period-update', updatePeriod);

      if (['kp', 'kn'].includes(xmlStatus)) {
        periodEl.classList.remove(classNames.liveStatus); // odebere třídu liveStatus
        periodEl.classList.add(classNames.baseClass, classNames.finStatus); // přidá defaultní třídu a třídu finStatus
      } else {
        periodEl.classList.add(classNames.baseClass, classNames.liveStatus); // přidá defaultní třídu a třídu liveStatus
      }

      updateLoadingEffect(element);
    }
  }
};
